import React from "react";
import { getPageNumbers } from "../utils/pagination";

export default function PaginationControls({
  page,
  totalPages,
  onPageChange,
  disabled = false,
}) {
  if (!totalPages || totalPages <= 1) return null;

  return (
    <div className="pagination">
      <button
        className="page-btn"
        disabled={disabled || page === 1}
        onClick={() => onPageChange(page - 1)}
      >
        ⬅ Prev
      </button>

      {getPageNumbers(page, totalPages).map((p, index) =>
        p === "..." ? (
          <span key={index} className="dots">
            ...
          </span>
        ) : (
          <button
            key={p}
            className={`page-btn ${page === p ? "active" : ""}`}
            onClick={() => onPageChange(p)}
          >
            {p}
          </button>
        )
      )}

      <button
        className="page-btn"
        disabled={disabled || page === totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Next ➡
      </button>
    </div>
  );
}

